// import { useState, useEffect } from "react";

// export default function QuestionCard({ q, onAnswer, chosen }) {
//   const [showResult, setShowResult] = useState(false);

//   // כשמקבלים תשובה חדשה, מראים את התוצאה
//   useEffect(() => {
//     if (chosen) {
//       setShowResult(true);
//       // נגינת צליל לפי תוצאה
//       playSound(chosen.isCorrect);
//     }
//   }, [chosen]);

//   // פונקציה לנגינת צלילים
//   const playSound = (isCorrect) => {
//     try {
//       let audio;
//       if (isCorrect) {
//         // צליל לתשובה נכונה
//         audio = new Audio('/sounds/correct.mp3'); // או כל נתיב אחר
//       } else {
//         // צליל לתשובה שגויה
//         audio = new Audio('/sounds/incorrect.mp3'); // או כל נתיב אחר
//       }
      
//       audio.volume = 0.5; // עוצמת קול
//       audio.play().catch(e => {
//         console.log('Cannot play audio:', e);
//         // אם אין קבצי צליל, פשוט לא נשמיע כלום
//       });
//     } catch (e) {
//       console.log('Audio not supported or file not found');
//     }
//   };

//   const handleAnswer = (answer) => {
//     if (chosen) return; // כבר נענה
//     onAnswer(answer.label);
//   };

//   // פונקציה לקבלת סגנון הכפתור
//   const getButtonStyle = (answer) => {
//     const baseStyle = {
//       background: '#dfeed9ff',
//       borderRadius: '10px',
//       border: '2px solid #ccc',
//       padding: '12px 16px',
//       margin: '6px',
//       cursor: chosen ? 'default' : 'pointer',
//       transition: 'all 0.3s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       fontSize: '1rem',
//       fontWeight: '500',
//       position: 'relative',
//       minHeight: '50px'
//     };

//     if (!chosen) {
//       return {
//         ...baseStyle,
//         '&:hover': {
//           transform: 'translateY(-2px)',
//           boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
//         }
//       };
//     }

//     // אם נבחרה תשובה, צבע לפי נכונות
//     const isSelected = chosen.chosenLabel === answer.label;
    
//     if (isSelected) {
//       if (chosen.isCorrect) {
//         // תשובה נכונה - מסגרת ירוקה
//         return {
//           ...baseStyle,
//           border: '3px solid #27ae60',
//           background: '#d5f4e6',
//           color: '#27ae60',
//           boxShadow: '0 4px 12px rgba(39, 174, 96, 0.3)'
//         };
//       } else {
//         // תשובה שגויה - מסגרת אדומה
//         return {
//           ...baseStyle,
//           border: '3px solid #e74c3c',
//           background: '#fdf2f2',
//           color: '#e74c3c',
//           boxShadow: '0 4px 12px rgba(231, 76, 60, 0.3)'
//         };
//       }
//     }

//     // כפתור לא נבחר
//     return {
//       ...baseStyle,
//       opacity: 0.6,
//       cursor: 'default'
//     };
//   };

//   // רכיב סימן (V או X)
//   const ResultIcon = ({ isCorrect }) => {
//     if (isCorrect) {
//       return (
//         <span style={{
//           color: '#27ae60',
//           fontSize: '1.5rem',
//           fontWeight: 'bold',
//           marginLeft: '8px'
//         }}>
//           ✓
//         </span>
//       );
//     } else {
//       return (
//         <span style={{
//           color: '#e74c3c',
//           fontSize: '1.5rem',
//           fontWeight: 'bold',
//           marginLeft: '8px'
//         }}>
//           ✗
//         </span>
//       );
//     }
//   };

//   return (
//     <div className="question-card" dir="rtl" style={{
//       background: 'var(--card)',
//       padding: '24px',
//       borderRadius: '16px',
//       margin: '16px 0',
//       boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
//     }}>
//       <div className="q-grid">
//         {q.imageUrl && (
//           <div style={{ marginBottom: '16px', textAlign: 'center' }}>
//             <img 
//               src={q.imageUrl} 
//               alt="שאלה" 
//               style={{
//                 maxWidth: '100%',
//                 maxHeight: '300px',
//                 borderRadius: '12px',
//                 boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
//               }}
//             />
//           </div>
//         )}

//         <div className="q-body">
//           <div style={{
//             fontSize: '1.2rem',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             // color: '#ffffff',
//             lineHeight: '1.5'
//           }}>
//             {q.prompt}
//           </div>

//           <div className="choices" style={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '8px'
//           }}>
//             {q.answers.map((answer, i) => {
//               const isSelected = chosen?.chosenLabel === answer.label;
//               return (
//                 <button
//                   key={i}
//                   onClick={() => handleAnswer(answer)}
//                   disabled={!!chosen}
//                   style={getButtonStyle(answer)}
//                 >
//                   <span>{answer.label}</span>
//                   {chosen && isSelected && (
//                     <ResultIcon isCorrect={chosen.isCorrect} />
//                   )}
//                 </button>
//               );
//             })}
//           </div>

//           {chosen && showResult && (
//             <div style={{
//               marginTop: '20px',
//               padding: '16px',
//               borderRadius: '12px',
//               border: `2px solid ${chosen.isCorrect ? '#27ae60' : '#e74c3c'}`,
//               background: chosen.isCorrect ? '#d5f4e6' : '#fdf2f2',
//               animation: 'fadeIn 0.5s ease-in'
//             }}>
//               <div style={{
//                 fontSize: '1.1rem',
//                 fontWeight: 'bold',
//                 color: chosen.isCorrect ? '#27ae60' : '#e74c3c',
//                 marginBottom: '8px',
//                 display: 'flex',
//                 alignItems: 'center'
//               }}>
//                 <ResultIcon isCorrect={chosen.isCorrect} />
//                 {chosen.isCorrect ? 'תשובה נכונה!' : 'תשובה שגויה'}
//               </div>
//               {chosen.explain && (
//                 <div style={{
//                   color: '#333',
//                   lineHeight: '1.5',
//                   fontSize: '0.95rem'
//                 }}>
//                   {chosen.explain}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
      
//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(-10px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </div>
//   );
// }



import { useState, useEffect } from "react";

/**
 * פונקציה פשוטה לאופטימיזציה של תמונות Cloudinary
 * מתאימה את הגודל לפי רוחב המסך
 */
function getOptimizedImageUrl(url, maxWidth = null) {
  // אם אין URL או שזה לא Cloudinary, מחזיר כמו שזה
  if (!url || !url.includes('cloudinary.com')) {
    return url;
  }

  // חישוב רוחב אופטימלי - מקסימום 800px לשאלות
  const screenWidth = typeof window !== 'undefined' ? window.innerWidth : 800;
  const width = maxWidth || Math.min(screenWidth, 800);

  // טרנספורמציות: רוחב, איכות אוטומטית, פורמט אוטומטי
  const transformations = `w_${width},q_auto:good,f_auto,c_limit,dpr_auto`;

  // מציאת מיקום /upload/ והוספת הטרנספורמציות
  const uploadIndex = url.indexOf('/upload/');
  if (uploadIndex === -1) {
    return url;
  }

  const beforeUpload = url.substring(0, uploadIndex + 8); // כולל '/upload/'
  const afterUpload = url.substring(uploadIndex + 8);

  return `${beforeUpload}${transformations}/${afterUpload}`;
}

export default function QuestionCard({ q, onAnswer, chosen }) {
  const [showResult, setShowResult] = useState(false);
  const [optimizedImageUrl, setOptimizedImageUrl] = useState('');

  // אופטימיזציה של התמונה בטעינה ובשינוי גודל מסך
  useEffect(() => {
    if (q.imageUrl) {
      setOptimizedImageUrl(getOptimizedImageUrl(q.imageUrl));
    }

    // עדכון בשינוי גודל חלון
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (q.imageUrl) {
          setOptimizedImageUrl(getOptimizedImageUrl(q.imageUrl));
        }
      }, 200);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [q.imageUrl]);

  // כשמקבלים תשובה חדשה, מראים את התוצאה
  useEffect(() => {
    if (chosen) {
      setShowResult(true);
      playSound(chosen.isCorrect);
    }
  }, [chosen]);

  // פונקציה לנגינת צלילים
  const playSound = (isCorrect) => {
    try {
      let audio;
      if (isCorrect) {
        audio = new Audio('/sounds/correct.mp3');
      } else {
        audio = new Audio('/sounds/incorrect.mp3');
      }
      
      audio.volume = 0.5;
      audio.play().catch(e => {
        console.log('Cannot play audio:', e);
      });
    } catch (e) {
      console.log('Audio not supported or file not found');
    }
  };

  const handleAnswer = (answer) => {
    if (chosen) return;
    onAnswer(answer.label);
  };

  // פונקציה לקבלת סגנון הכפתור
  const getButtonStyle = (answer) => {
    const baseStyle = {
      background: '#dfeed9ff',
      borderRadius: '10px',
      border: '2px solid #ccc',
      padding: '12px 16px',
      margin: '6px',
      cursor: chosen ? 'default' : 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '1rem',
      fontWeight: '500',
      position: 'relative',
      minHeight: '50px'
    };

    if (!chosen) {
      return baseStyle;
    }

    const isSelected = chosen.chosenLabel === answer.label;
    
    if (isSelected) {
      if (chosen.isCorrect) {
        return {
          ...baseStyle,
          border: '3px solid #27ae60',
          background: '#d5f4e6',
          color: '#27ae60',
          boxShadow: '0 4px 12px rgba(39, 174, 96, 0.3)'
        };
      } else {
        return {
          ...baseStyle,
          border: '3px solid #e74c3c',
          background: '#fdf2f2',
          color: '#e74c3c',
          boxShadow: '0 4px 12px rgba(231, 76, 60, 0.3)'
        };
      }
    }

    return {
      ...baseStyle,
      opacity: 0.6,
      cursor: 'default'
    };
  };

  // רכיב סימן (V או X)
  const ResultIcon = ({ isCorrect }) => {
    if (isCorrect) {
      return (
        <span style={{
          color: '#27ae60',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          marginLeft: '8px'
        }}>
          ✓
        </span>
      );
    } else {
      return (
        <span style={{
          color: '#e74c3c',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          marginLeft: '8px'
        }}>
          ✗
        </span>
      );
    }
  };

  return (
    <div className="question-card" dir="rtl" style={{
      background: 'var(--card)',
      padding: '24px',
      borderRadius: '16px',
      margin: '16px 0',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
    }}>
      <div className="q-grid">
        {q.imageUrl && (
          <div style={{ marginBottom: '16px', textAlign: 'center' }}>
            <img 
              src={optimizedImageUrl || q.imageUrl} 
              alt="שאלה" 
              loading="lazy"
              style={{
                maxWidth: '100%',
                maxHeight: '300px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>
        )}

        <div className="q-body">
          <div style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '20px',
            lineHeight: '1.5'
          }}>
            {q.prompt}
          </div>

          <div className="choices" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {q.answers.map((answer, i) => {
              const isSelected = chosen?.chosenLabel === answer.label;
              return (
                <button
                  key={i}
                  onClick={() => handleAnswer(answer)}
                  disabled={!!chosen}
                  style={getButtonStyle(answer)}
                >
                  <span>{answer.label}</span>
                  {chosen && isSelected && (
                    <ResultIcon isCorrect={chosen.isCorrect} />
                  )}
                </button>
              );
            })}
          </div>

          {chosen && showResult && (
            <div style={{
              marginTop: '20px',
              padding: '16px',
              borderRadius: '12px',
              border: `2px solid ${chosen.isCorrect ? '#27ae60' : '#e74c3c'}`,
              background: chosen.isCorrect ? '#d5f4e6' : '#fdf2f2',
              animation: 'fadeIn 0.5s ease-in'
            }}>
              <div style={{
                fontSize: '1.1rem',
                fontWeight: 'bold',
                color: chosen.isCorrect ? '#27ae60' : '#e74c3c',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <ResultIcon isCorrect={chosen.isCorrect} />
                {chosen.isCorrect ? 'תשובה נכונה!' : 'תשובה שגויה'}
              </div>
              {chosen.explain && (
                <div style={{
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '0.95rem'
                }}>
                  {chosen.explain}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
